(() => {
  const searchButton = $(".c-site-header__search-toggle");
  const closeSearchButton = $(".c-site-header__close-search-toggle");
  const menuWrapper = $(".c-site-header__desktop-wrapper");
  const searchWrapper = $(".c-site-header__mobile-search");

  searchButton.on("click", () => {
    menuWrapper.hide();
    searchWrapper.show();
  });

  closeSearchButton.on("click", () => {
    menuWrapper.show();
    searchWrapper.hide();
  });
})();
